import React, { useState } from 'react';
import axios from 'axios';

const RunCustomAppCard = () => {
  const [appName, setAppName] = useState('');
  const [paramSchema, setParamSchema] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadAppMetadata = async () => {
    if (!appName.trim()) return;

    try {
      const res = await axios.get(`/Get_App_Metadata/${appName}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setParamSchema(res.data.parameters);
      setFormValues({});
      setResult(null);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to load metadata');
      setParamSchema([]);
    }
  };

  const handleInputChange = (name, type, value) => {
    let parsedValue = value;
    if (type === "int") parsedValue = parseInt(value);
    if (type === "float") parsedValue = parseFloat(value);
    if (type === "bool") parsedValue = value === "true";

    setFormValues((prev) => ({
      ...prev,
      [name]: parsedValue
    }));
  };

  const handleRun = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const res = await axios.post("http://localhost:8000/Run_Custom_App", {
        app_name: appName,
        params: formValues
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });
      setResult(res.data.result);
    } catch (err) {
      setError(err.response?.data?.detail || "Execution failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
  <div className="card border-0 shadow rounded-4">
    <div className="card-header bg-dark text-white py-3 px-4 rounded-top-4 d-flex justify-content-between align-items-center">
      <h4 className="mb-0">⚙️ Run Custom App</h4>
      <span className="badge bg-secondary fs-6">App Executor</span>
    </div>

    <div className="card-body p-4">
      {/* App Name Input */}
      <div className="mb-4">
        <label className="form-label fw-semibold">App Name</label>
        <input
          className="form-control form-control-lg border border-dark"
          placeholder="🔍 Search or enter app name..."
          value={appName}
          onChange={(e) => setAppName(e.target.value)}
          onBlur={loadAppMetadata}
        />
        <small className="text-muted">We'll auto-load parameters if this matches a saved app.</small>
      </div>

      {/* Parameter Inputs */}
      {paramSchema.length > 0 && (
        <>
          <div className="border-start border-4 border-primary ps-4 py-3 bg-light rounded-3 mb-4">
            <h5 className="fw-bold mb-3">🧩 Input Parameters</h5>
            {paramSchema.map((param, idx) => (
              <div key={idx} className="mb-3">
                <label className="form-label">
                  {param.name}{" "}
                  <span className="badge bg-light text-dark border border-secondary">{param.type}</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={`Enter a ${param.type} value`}
                  onChange={(e) => handleInputChange(param.name, param.type, e.target.value)}
                />
              </div>
            ))}
          </div>

          <div className="d-grid">
            <button
              className="btn btn-primary btn-lg"
              onClick={handleRun}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Executing...
                </>
              ) : (
                '🚀 Run App'
              )}
            </button>
          </div>
        </>
      )}

      {/* Result Output */}
      {result && (
        <div className="alert alert-success mt-4 shadow-sm border border-success">
          <h6 className="mb-2">✅ Output:</h6>
          <pre className="bg-light p-3 rounded small font-monospace">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}

      {/* Error Handling */}
      {error && (
        <div className="alert alert-danger mt-4 shadow-sm border border-danger">
          <h6 className="mb-2">❌ Error:</h6>
          <div>{error}</div>
        </div>
      )}
    </div>
  </div>
</div>
  );
};

export default RunCustomAppCard;